module.exports = __webpack_public_path__ + "img/default-thumb.b07198e5.png";